import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Lock } from "lucide-react";
import { api, setAdminToken } from "@/lib/api";

const inputCls = "w-full border-2 border-slate-200 rounded-sm px-3 py-2.5 text-sm focus:outline-none focus:border-brand-orange transition-colors";

export default function AdminLogin() {
    const [u, setU] = useState("");
    const [p, setP] = useState("");
    const [busy, setBusy] = useState(false);
    const nav = useNavigate();

    async function submit(e) {
        e.preventDefault();
        setBusy(true);
        try {
            const r = await api.post("/admin/login", { username: u, password: p });
            setAdminToken(r.data.token);
            toast.success(`Welcome, ${r.data.username}`);
            nav("/admin");
        } catch (err) {
            toast.error(err?.response?.data?.detail || "Login failed");
        } finally {
            setBusy(false);
        }
    }

    return (
        <div className="min-h-screen bg-brand-navy flex items-center justify-center px-4" data-testid="admin-login-page">
            <div className="diagonal-stripes h-1.5 w-full absolute top-0 left-0" />
            <form onSubmit={submit} className="w-full max-w-md bg-white border-2 border-slate-200 p-8">
                <div className="flex items-center gap-3 mb-6">
                    <Lock className="h-6 w-6 text-brand-orange" />
                    <h1 className="font-heading text-2xl font-black uppercase text-brand-navy">Admin Sign In</h1>
                </div>
                <div className="space-y-4">
                    <div>
                        <label className="block text-xs uppercase tracking-wider text-slate-600 font-bold mb-1.5">Username</label>
                        <input className={inputCls} value={u} onChange={(e) => setU(e.target.value)} data-testid="admin-username" autoFocus />
                    </div>
                    <div>
                        <label className="block text-xs uppercase tracking-wider text-slate-600 font-bold mb-1.5">Password</label>
                        <input className={inputCls} type="password" value={p} onChange={(e) => setP(e.target.value)} data-testid="admin-password" />
                    </div>
                </div>
                <button type="submit" disabled={busy} className="mt-6 w-full bg-brand-orange hover:bg-brand-navy text-white font-heading uppercase tracking-wider font-bold py-3 rounded-sm disabled:opacity-60 transition-colors" data-testid="admin-login-btn">
                    {busy ? "Signing in..." : "Sign In"}
                </button>
            </form>
        </div>
    );
}
